// extracted by extract-css-chunks-webpack-plugin
module.exports = {"card":"Card-9ca4122733198b7c"};